import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiPlus, FiMinus } from 'react-icons/fi';

export const FaqItem = ({ question, answer, isOpen, toggle }) => (
  <div className="border-b border-rose-900/10 mb-2">
    <button
      onClick={toggle}
      className="w-full py-6 flex justify-between items-center text-left focus:outline-none group"
    >
      <span className={`text-lg font-bold transition-colors duration-300 ${isOpen ? 'text-rose-600' : 'text-rose-950 group-hover:text-rose-500'}`}>
        {question}
      </span>
      <div className={`p-2 rounded-full transition-all duration-300 ${isOpen ? 'bg-rose-500 text-white rotate-180' : 'bg-rose-50 text-rose-400'}`}>
        {isOpen ? <FiMinus size={18} /> : <FiPlus size={18} />}
      </div>
    </button>
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          className="overflow-hidden"
        >
          <p className="pb-6 text-rose-900/60 leading-relaxed font-medium">{answer}</p>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);